"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lupaTranslations = {
    goals: "Goals",
};
exports.default = lupaTranslations;
